<template>
  <div class="login">
    <div class="form-box">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item
          label="用户名"
          prop="loginName"
          :rules="[
      { required: true, message: '用户名不能为空'},
    ]"
        >
          <el-input v-model="form.loginName" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          :rules="[
      { required: true, message: '密码不能为空'},
    ]"
          prop="loginPwd"
        >
          <el-input type="password" v-model="form.loginPwd" placeholder="请输入密码" autocomplete="off"></el-input>
        </el-form-item>
        <div class="btn-box">
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        loginName: "",
        loginPwd: ""
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            const res = await this.$http.post(
              process.env.LOGIN_URL,
              this.form
            );
            if (res.code === "200") {
              localStorage.setItem(
                "ssoUser",
                JSON.stringify({
                  account: res.data.account,
                  id: res.data.id
                })
              );
              localStorage.setItem("account", res.data.account);
              this.$message.success(res.message);
              this.$router.push({ path: `/` });
            } else {
              this.$message.error(res.message);
            }
          } catch (err) {
            this.$message.error(err.message);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.login {
  width: 100%;
  height: 100vh;
  background: #409eff;
  position: relative;
}
.form-box {
  width: 400px;
  height: 200px;
  padding: 30px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -200px;
  margin-top: -100px;
  border-radius: 10px;
}
.btn-box {
  text-align: center;
  clear: both;
  overflow: hidden;
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue